/**
 * The deep link URLs available for navigation within the application.
 */
export enum DeepLinkUrl {
    HOME = 'home',
    CATALOG = 'catalog',
    ORDERS = 'orders',
    COUPONS = 'coupons',
    NEWS = 'news',
    PROMOTIONS = 'promotions',
    LISTS = 'lists',
    USUAL_PURCHASE = 'usual-purchase',
    FAVORITES = 'favorites',
    BEST_SELLERS = 'best-sellers',
    COMPARATOR = 'comparator',
    CHANGE_EMAIL = 'change-email',
    CHANGE_PASSWORD = 'change-password',
    CHECKOUT = 'checkout',
    ACCOUNT = 'account',
    PRODUCT_DETAIL = 'product-detail',
    CATEGORIES = 'categories',
    PROMOTION_DETAIL = 'promotion-detail',
    LOGIN = 'login',
    SHARED = 'shared',
}

/**
 * Processed deep link, modeled with a navigation path and optional parameters.
 */
export class DeepLink {
    constructor(
        readonly path: DeepLinkUrl,
        readonly parameters?: Record<string, any>,
    ) {}
}
